import { Routes, BrowserRouter, Route } from 'react-router-dom';
import store from './store'
import {connect, Provider} from 'react-redux';
import Navbar from './component/Header/Navbar'
import Footer from './component/Footer/Footer';
import Home from './component/Home/Home'
import Profile from './component/Profile/Profile';
import ProfileDetails from './component/Profile/ProfileDetails';
import './style.css';
import Authorize from "./component/Authorize";
import Invalidation from "./component/Invalidation";
import MassiveReprocessing from "./component/MassiveReprocessing";
import React, {useEffect, useState} from "react";
import {loginWithToken, sendToken, setMaintenanceStatus} from "./action/auth";
import axiosHandler from "./services/https";
import {LOGOUT} from "./action/types";
import {CloseButton, Col, Offcanvas, ProgressBar, Row} from "react-bootstrap";
import MaintenancePage from "./component/MaintenancePage/MaintenancePage";
import DownloadManager from "./component/DownloadManager/DownloadManager";
import {addItemsToQueue} from "./action/download";
const App = ({ loginWithToken, sendToken, maintenanceStatus, setMaintenanceStatus, addItemsToQueue }) => {

	useEffect(() => {
		// App initializing
		window.addEventListener("message", (event) => {
			if (event.data.access_token && event.data.refresh_token && event.data.id_token) {
				console.log(`Token received from WebGIS`, event.data); // Message received from iframe
			}
			if (event.data.ready) {
				console.log(`WegGIS is Ready! Sending the token...`);
				sendToken();
			}
			if (event.data.expired) {
				console.log(`Token has expired!`);
				this.store.dispatch({
					type: LOGOUT
				});
			}
			if (event.data.queueItems && event.data.queueItems.length) { // aggiunta elementi alla coda di download
				console.log(`Adding items to download queue`, event.data.queueItems);
				// invio alla coda di download (in questo caso arrivano già pronti)
				addItemsToQueue(event.data.queueItems.filter(selectedItem => selectedItem));
			}
		});

		// token Data
		let accessToken = localStorage.getItem('access');
		let refreshToken = localStorage.getItem('refresh');
		let idToken = localStorage.getItem('id');
		if (accessToken && refreshToken && idToken) {
			loginWithToken({data: {
				access_token: accessToken,
				refresh_token: refreshToken,
				id_token: idToken
			}});
		}

		// Starting up interceptor with store
		const maint_url = `${process.env.REACT_APP_API_URL}/maintenance_status`;
		axiosHandler.getInstance(store).get(maint_url)
		.then(res => {
			setMaintenanceStatus(res.data);
		}).catch(err => {
			console.log('Error getting the maintenance status');
		});
	}, []);

	useEffect(() => {
		if (maintenanceStatus && maintenanceStatus.banner) {
			setShowMaintenance(true);
		}
	}, [maintenanceStatus])

	const [showMaintenance, setShowMaintenance] = useState(false);
	const toggleShowMaintenance = () => {
		setShowMaintenance(!showMaintenance)
	}

	return <div>
		<Provider store={store}>
			{maintenanceStatus && maintenanceStatus.page ?
				<>
					<MaintenancePage page={maintenanceStatus.page} />
					<Footer/>
				</> :
				<>
					<BrowserRouter>
						<Navbar/>
						<Routes>
							<Route path="profile" element={<Profile/>}/>
							<Route path="profile/details/:orderId" element={<ProfileDetails/>}/>
							<Route path="invalidate" element={<Invalidation/>}/>
							<Route path="reprocess" element={<MassiveReprocessing/>}/>
							<Route path="authorize" element={<Authorize/>} />
							<Route path="/" element={<Home/>}></Route>
						</Routes>

						{
							maintenanceStatus && maintenanceStatus.banner !== "" &&

							<Offcanvas placement="bottom" height="10vh" show={showMaintenance} onHide={toggleShowMaintenance} style={{height: 'fit-content'}}>
								{/*<Offcanvas.Header closeButton>*/}
								{/*	<Offcanvas.Title>Maintenance Banner</Offcanvas.Title>*/}
								{/*</Offcanvas.Header>*/}
								<Offcanvas.Body>
									<CloseButton style={{float: 'right', marginRight: "10px"}} onClick={toggleShowMaintenance} />
									<div>{maintenanceStatus.banner}</div>
								</Offcanvas.Body>
							</Offcanvas>
						}
						<Footer/>
					</BrowserRouter>
					<DownloadManager />
				</>
			}
		</Provider>
	</div>
}

const mapStateToProps = state => ({
	maintenanceStatus: state.auth.maintenanceStatus,
});
export default connect(mapStateToProps, { loginWithToken, sendToken, setMaintenanceStatus, addItemsToQueue })(App)
